import React from 'react';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import heroCat from '../images/cat.webp';
import collectible1 from '../images/collection/IMG_2573.PNG';
import collectible2 from '../images/collection/IMG_2578.PNG';
import collectible3 from '../images/collection/IMG_2621.PNG';
import collectible4 from '../images/collection/IMG_2623.PNG';

const GALLERY = [collectible1, collectible2, collectible3, collectible4];

const OPENSEA_URL = 'https://opensea.io/collection/lilverse';

const NftGallery = () => {
    return (
        <div className="w-full">
            <Header />
            <div className="w-full bg-[#FEEEDE] flex flex-col items-center gap-8 py-12 px-4">
                <img src={heroCat} alt="Lilverse cat collectible" className="w-[220px] md:w-[300px] h-auto" />
                <div className="text-center max-w-2xl">
                    <h1 className="font-dang text-[#FE9ECE] text-with-border text-[10vw] md:text-[4vw] leading-tight">Lilverse NFT</h1>
                    <p className="font-mons text-lg md:text-2xl mt-4">
                        Owning our digital collectibles is the way to show your love to lils.
                        Each lil is unique, appears in your favorite animations, and has its own traits.
                    </p>
                    <p className="font-mons text-lg md:text-2xl">Own a piece of history.</p>
                </div>
                {/* The marketplace link was previously withheld because the collection was mid-migration
                    and the old Solana-era listing was not a valid destination. That destination now exists
                    and is verified: the live Robinhood Chain collection on OpenSea. */}
                <a
                    href={OPENSEA_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-mons text-sm md:text-base text-[#FE9ECE] uppercase tracking-wide underline underline-offset-4 decoration-2 hover:text-[#FD62A6] transition-colors"
                >
                    Now live on Robinhood Chain &mdash; view the collection on OpenSea
                </a>
            </div>
            <div className="w-full bg-white py-12 px-4">
                <h3 className="font-mons text-center text-2xl md:text-4xl mb-10">Lilverse digital collectibles</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto">
                    {GALLERY.map((img, i) => (
                        <div key={i} className="rounded-2xl overflow-hidden bg-[#FEEEDE] aspect-square flex items-center justify-center p-3">
                            <img src={img} alt={`Lilverse collectible ${i + 1}`} className="w-full h-full object-contain" />
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default NftGallery;
